<template>
    <div id="canvas">
        <v-chart :options="option"></v-chart>
    </div>
</template>
<script>
import echarts from 'echarts'
import {showWork,Config} from './dataPie'
    let this_=this;
export default {
    props:{
        canvasList:{
            type:Array,
            default:()=>[]
        }
    },
    data(){
        return{
            option:Config.pieOptions
        }
    },
    created(){
        this.getData();
    },
    methods:{
        getData(){
            let arr = [];
            this.canvasList.forEach((item)=>{
                arr.push({value:item.percent,name:item.subjectName+(item.percent<10 ? "  ":"")+item.percent+'%'})
            })
            showWork(arr);
        }
    }
}
</script>
<style lang="less" scoped>
#canvas{
    width:100%;
    height: 100%;
}
/deep/ .echarts{
    width:100%;
    height: 100%;
}
</style>